import {gql} from "@apollo/client";

export const POST_JOB = gql`
	mutation postJob ($input: PostJobInput!) {
		  postJob(input: $input) {
			 job {id}
		}
	}
`;
